export const VALIDATION_ERROR = {
  EMAIL: "Invalid email format. Please enter a correct email.",
  PASS: "Password needs at least 1 uppercase, 1 lowercase, 1 number and 1 special char. Min 8 chars.",
  PASS_REP: "Passwords don't match.",
  TERMS: "Accept terms is required."
}

